/**
 * RemitSlice State Definition
 * 
 * Defines the state interface and initial state for the remit slice.
 */

import { RemitView, RemitSummaryView } from '../types/remitTypes';

/**
 * State interface for the remit slice.
 * Follows the standard pattern with remit-specific naming.
 */
export interface RemitSliceState {
  /** The current remit being viewed/edited, or null if none selected */
  currentRemit: RemitView | null;
  /** Backup of the remit for discard functionality */
  remitBackup: RemitView | null;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
  /** Loading state for async operations */
  isLoading: boolean;
  /** Currently selected claim ID within the remit */
  selectedClaimId: string | null;
  /** Currently selected service line ID within the selected claim */
  selectedServiceLineId: string | null;
}

/**
 * Initial state for the remit slice.
 */
export const initialState: RemitSliceState = {
  currentRemit: null,
  remitBackup: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
  isLoading: false,
  selectedClaimId: null,
  selectedServiceLineId: null,
};
